import React from "react";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import loginInfo from "../../images/underconstruction.jpg";
// import loginBanner from "../../images/banner-login.jpg";
// import { MdOutlineEmail } from "react-icons/md";
// import { FiLock } from "react-icons/fi";
// import { FiUnlock } from "react-icons/fi";
// import { ErrorMessage, Field, Form, Formik } from "formik";
// import * as Yup from "yup";
// import { IoMdClose } from "react-icons/io";
// import { FaCheck } from "react-icons/fa6";

function RegisterModal({ show, onHide, loginShow, loginHide }) {
    // const [isVisible, setVisible] = useState({ password: true, cPassword: true });
    // const [strengthInfo, setStrengthInfo] = useState({
    //     strength: { length: false, number: false, specialChar: false, letter: false },
    //     isStrong: false,
    // });
    // const checkPasswordStrength = (password) => {
    //     const lengthCriteria = password.length >= 8;
    //     const numberCriteria = /\d/.test(password);
    //     const specialCharCriteria = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    //     const letterCriteria = /[a-zA-Z]/.test(password);
    //     const strength = {
    //         length: lengthCriteria,
    //         number: numberCriteria,
    //         specialChar: specialCharCriteria,
    //         letter: letterCriteria,
    //     };
    //     const isStrong = Object.values(strength).every(Boolean);
    //     return { strength, isStrong };
    // };
    // const handleToggle = (key) => setVisible((prev) => ({ ...prev, [key]: !prev[key] }));
    // const handlePasswordChange = (e) => {
    //     const newPassword = e.target.value;
    //     setStrengthInfo(checkPasswordStrength(newPassword));
    // };

    // const setSubmitData = (formData) => {};

    return (
        <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" className="login-modal" show={show} centered>
            <Modal.Body>
                <div className="flat-account">
                    {/* <div className="banner-account">
                        <img src={loginBanner} alt="sign up" />
                    </div> */}
                    <div className="form-account">
                        <div className="text-end">
                            {/* <div className="title-box"> */}
                            {/* <h4>Register</h4> */}
                            <button onClick={onHide} className="login-close">
                                <IoClose />
                            </button>
                        </div>
                        {/* <Formik
                            initialValues={{ email: "", password: "", cPassword: "" }}
                            validationSchema={Yup.object().shape({
                                email: Yup.string().email("Your email address must be in the format of name@domain.com.").required("Email is required."),
                                password: Yup.string().required("Password is required."),
                                // .matches(
                                //     /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&_^#])[A-Za-z\d@$!%*?&_^#]{8,20}$/,
                                //     "Password must contain at least one number, one uppercase letter, one lowercase letter and one symbol i.e. @, $, !, %, *, &, _, #, ^ etc. Password length should be 8 to 16 characters."
                                // ),
                                cPassword: Yup.string()
                                    .required("Confirm password is required.")
                                    .test("passwords-match", "Confirm password does not match password.", function (value) {
                                        return this.parent.password === value;
                                    }),
                            })}
                            onSubmit={(values, { resetform }) => {
                                setSubmitData(values, resetform);
                            }}
                        >
                            {(runform) => (
                                <Form onSubmit={runform.handleSubmit}>
                                    <div className="box">
                                        <div className="box-fieldset">
                                            <label>Email</label>
                                            <div className="ip-field">
                                                <MdOutlineEmail className="icon" />
                                                <Field
                                                    type="text"
                                                    name="email"
                                                    className={`form-control${runform?.errors?.email && runform?.touched?.email ? " input-error" : ""}`}
                                                    placeholder="Enter your email"
                                                />
                                            </div>
                                            <ErrorMessage name="email" component="span" className="error-message" />
                                        </div>
                                        <div className="box-fieldset">
                                            <label>Password</label>
                                            <div className="ip-field">
                                                {isVisible?.password ? (
                                                    <FiLock className="icon" onClick={() => handleToggle("password")} />
                                                ) : (
                                                    <FiUnlock className="icon" onClick={() => handleToggle("password")} />
                                                )}
                                                <Field
                                                    type={isVisible?.password ? "password" : "text"}
                                                    name="password"
                                                    className={`form-control${runform?.errors?.password && runform?.touched?.password ? " input-error" : ""}`}
                                                    onChange={(e) => {
                                                        runform.handleChange(e);
                                                        handlePasswordChange(e);
                                                    }}
                                                    placeholder="Enter your password"
                                                    maxLength="20"
                                                />
                                            </div>
                                            <ErrorMessage name="password" component="span" className="error-message" />
                                            {runform?.touched?.password && (
                                                <>
                                                    <strong>Password Strength:</strong> {strengthInfo.isStrong ? "Strong" : "Weak"}
                                                    <div>
                                                        <h6>Password must contain at least:</h6>
                                                        <ul>
                                                            <li>{strengthInfo.strength.length ? <FaCheck color="green" /> : <IoMdClose color="red" />} 8 characters</li>
                                                            <li>{strengthInfo.strength.number ? <FaCheck color="green" /> : <IoMdClose color="red" />} 1 number</li>
                                                            <li>{strengthInfo.strength.specialChar ? <FaCheck color="green" /> : <IoMdClose color="red" />} 1 special character</li>
                                                            <li>{strengthInfo.strength.letter ? <FaCheck color="green" /> : <IoMdClose color="red" />} 1 letter</li>
                                                        </ul>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                        <div className="box-fieldset">
                                            <label>Confirm Password</label>
                                            <div className="ip-field">
                                                {isVisible?.cPassword ? (
                                                    <FiLock className="icon" onClick={() => handleToggle("cPassword")} />
                                                ) : (
                                                    <FiUnlock className="icon" onClick={() => handleToggle("cPassword")} />
                                                )}
                                                <Field
                                                    type={isVisible?.cPassword ? "password" : "text"}
                                                    name="cPassword"
                                                    className={`form-control${runform?.errors?.cPassword && runform?.touched?.cPassword ? " input-error" : ""}`}
                                                    placeholder="Enter your confirm password"
                                                    maxLength="20"
                                                />
                                            </div>
                                            <ErrorMessage name="cPassword" component="span" className="error-message" />
                                        </div>
                                    </div>

                                    <div className="form-btn mt-4">
                                        <button type="submit" className="button">
                                            Register
                                        </button>
                                        {loginHide && (
                                            <div className="register-text">
                                                Already have an account?
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        loginShow();
                                                        onHide();
                                                    }}
                                                >
                                                    Login
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </Form>
                            )}
                        </Formik> */}
                        <div className="text-center">
                            <img src={loginInfo} alt="Under Construction" />
                            <h2>Under Construction !</h2>
                            <p>The web page is coming soon</p>
                        </div>
                        {/* <div className="module-text">
                                <span>OR</span>
                            </div>
                            <div className="group-btn">
                                <a href="#" className="btn-social"><FcGoogle /><span> Continue with Google</span></a>
                                <a href="#" className="btn-social"><FaFacebook /><span> Continue with Facebook</span></a>
                            </div> */}
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default RegisterModal;
